import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ISendImpactAnalysisEmailsParams {
  contentType: 'datasource' | 'table';
  contentId: string;
  subject: string;
  body: string;
  userIds: ReadonlyArray<string>;
}

export interface ISendImpactAnalysisEmailsResult extends IResult {
}

export class SendImpactAnalysisEmailsRequest extends Request<ISendImpactAnalysisEmailsParams, ISendImpactAnalysisEmailsResult> {
  constructor(params: ISendImpactAnalysisEmailsParams) {
    super('sendImpactAnalysisEmails', params);
  }
}
